import React, { useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import PropTypes from "prop-types";
// import WertModule from "@wert-io/module-react-component";
import { ethers } from "ethers";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import {
  mintingInProgressSuccess,
  genericAbiWrite,
  mintError,
  transactionSuccess,
} from "../../../../redux/contracts";
import { getMintTierAttributes } from "../../../../redux/mintTiers";
import { isServer } from "../../../../redux/store";
import checkCurrency from "../../../../utils/checkForCurrency";
import { REACT_APP_PROJECT_ID } from "../../../../utils/env";
import { showWallet } from "../../../../redux/wallets";

const MintButtons = (
  {
    mintTierId,
    mintPrice,
    disabled,
    availableAmount,
    alreadyMintedAmount,
    usdMintPrice,
    showConceriergePayment,
  },
  context
) => {
  const dispatch = useDispatch();
  const { account, provider } = useWeb3React();
  const [tokenCounter, setTokenCounter] = useState(1);
  const formattedMintPrice = mintPrice
    ? ethers.utils.formatEther(mintPrice)
    : mintPrice;
  const [balance, setBalance] = useState(null);
  useEffect(() => {
    if (!!account && !!provider) {
      let stale = false;

      provider
        .getBalance(account)
        .then((balance) => {
          if (!stale) {
            setBalance(balance.toString());
          }
        })
        .catch(() => {
          if (!stale) {
            setBalance(null);
          }
        });

      return () => {
        stale = true;
        setBalance(undefined);
      };
    }
  }, [account, provider]);

  const refreshWallet = () => {
    if (account)
      dispatch(
        showWallet({ address: account, project_id: REACT_APP_PROJECT_ID })
      );
  };

  const hasEnoughBalance = mintPrice
    ? account &&
      balance &&
      ethers.utils.formatEther(balance) > ethers.utils.formatEther(mintPrice)
    : true;
  const maxAmount = availableAmount - alreadyMintedAmount;
  console.log("mintPrice", mintPrice);

  const mintTier = useSelector((state) =>
    getMintTierAttributes(state, mintTierId)
  );

  const decrement = () => {
    if (tokenCounter > 1) {
      setTokenCounter(tokenCounter - 1);
    }
  };
  const increment = () => {
    if (tokenCounter < maxAmount) {
      setTokenCounter(tokenCounter + 1);
    }
  };
  const [showConceriegeStep, setShowConceriegeStep] = useState(false);
  const [shopifyLoaded, setShopifyLoaded] = useState(false);
  const [showBuyModalButtons, setShowBuyModalButtons] = useState(true);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const [showInitialLoading, setShowInitialLoading] = useState(false);

  const [preventCloseAlert, setPreventCloseAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);

  const handleMint = async () => {
    setShowBuyModal(false);
    setShowBuyModalButtons(true);
    console.log("mint price", (tokenCounter * mintPrice).toString());
    dispatch(
      genericAbiWrite({
        functionAbi: mintTier?.mint_abi,
        contractAddress: mintTier?.contract_address,
        account: account,
        payableValue: (tokenCounter * mintPrice).toString(),
        provider: provider,
        genericInputs: {
          quantity: tokenCounter,
          tokenReceiver: account,
          minter: account,
          mintpass: {
            // TODO  mintpass object should be build with signature_type
            wallet: account,
            tier: mintTier?.internal_tier_id,
          },
          mintpassSignature: "0x" + mintTier?.mint_pass_signature,
        },
        successCallbackFnc: (data) => {
          console.log("success Data", data);
          dispatch(mintingInProgressSuccess(data));
        },
        errorCallbackFnc: (data) => {
          console.log("error Data", data);
          dispatch(mintError(data));
        },
        transactionCallbackFnc: (data) => {
          console.log("transfer data", data);
          dispatch(transactionSuccess(data));
          refreshWallet();
        },
      })
    );
  };

  const preventCloseModal = false;

  const closeBuyModal = () => {
    if (!preventCloseModal) {
      setShowBuyModal(false);
      setShowConceriegeStep(false);
      setShowBuyModalButtons(true);
      setPreventCloseAlert(false);
      setSuccessAlert(false);
      setShowInitialLoading(false);
      setShopifyLoaded(false);
    } else {
      setPreventCloseAlert(true);
    }
  };

  const handleShopfiyMint = () => {
    if (shopifyLoaded) {
      return;
    } else {
      setShopifyLoaded(true);
    }
    setShowConceriegeStep(true);
    setShowBuyModalButtons(false);

    (function () {
      var scriptURL = "/buybutton.min.js";
      if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
          ShopifyBuyInit();
        } else {
          loadScript();
        }
      } else {
        loadScript();
      }
      function loadScript() {
        var script = document.createElement("script");
        script.async = true;
        script.src = scriptURL;
        (
          document.getElementsByTagName("head")[0] ||
          document.getElementsByTagName("body")[0]
        ).appendChild(script);
        script.onload = ShopifyBuyInit;
      }
      function ShopifyBuyInit() {
        var client = window.ShopifyBuy.buildClient({
          domain: "arctic-blue-shop.myshopify.com",
          storefrontAccessToken: "c937226e045e13da71fe000698edca83",
        });
        var ui = window.ShopifyBuy.UI.init(client);
        ui.createComponent("product", {
          id: "7902799560867",
          node: document.getElementById("product-component-1668097358168"),
          moneyFormat: "%7B%7Bamount_with_comma_separator%7D%7D%20%E2%82%AC",
          customAttributes: [{ key: "Wallet Address", value: account }],
          quantity: 5,
          options: {
            product: {
              buttonDestination: "checkout",
              contents: {
                img: false,
                button: true,
                buttonWithQuantity: false,
                title: false,
                price: false,
                options: false,
                properties: false,
              },
              text: {
                button: "Pay now",
              },
              styles: {
                button: {
                  "font-weight": "bold",
                  "font-size": "16px",
                  "padding-top": "16px",
                  "padding-bottom": "16px",
                  ":hover": {
                    "background-color": "#0032A0",
                  },
                  "background-color": "#0032A0",
                  ":focus": {
                    "background-color": "#0032A0",
                  },
                  "border-radius": "0px",
                  "padding-left": "50px",
                  "padding-right": "50px",
                  width: "100%",
                },
              },
              order: ["button"],
            },
          },
        });
      }
    })();
  };

  const checkStatus =
    !isServer &&
    window.ethereum &&
    window.ethereum.networkVersion &&
    typeof window.ethereum.networkVersion === "string";

  const usdPrice = parseFloat(usdMintPrice / 100000000);

  return (
    <>
      <div className="d-flex justify-content-around px-5 py-3">
        {availableAmount > 1 && (
          <Button
            className="border-0 cursor-pointer"
            onClick={decrement}
            outline
            color="primary"
            disabled={tokenCounter <= 1}
          >
            <AiOutlineMinus size={30} className="" />
          </Button>
        )}
        <div className="d-flex align-items-center">
          <span className="h2">{tokenCounter}</span>
        </div>
        {availableAmount > 1 && (
          <Button
            className="border-0 cursor-pointer"
            color="primary"
            onClick={increment}
            outline
            disabled={tokenCounter >= maxAmount}
          >
            <AiOutlinePlus size={30} />
          </Button>
        )}
      </div>

      <p className="mt-3 text-muted mb-1">{context.t("Current Price")}</p>
      <div className="d-flex justify-content-center">
        {usdPrice > 0 && (
          <span className="fw-bold me-1">
            {tokenCounter * usdPrice}
            {" USD"}
          </span>
        )}
        {mintPrice > 0 && (
          <p className="p font-weight-bold ms-1">
            ({tokenCounter * ethers.utils.formatEther(mintPrice)}
            {" ETH"})
          </p>
        )}
      </div>

      <div className="my-3 d-grid gap-2 col-sm-12 col-md-8 mx-auto">
        <Button
          className="text-white"
          disabled={!!availableAmount && disabled}
          // outline
          color="primary"
          onClick={
            mintPrice
              ? () => {
                  setShowBuyModal(true);
                  setShowBuyModalButtons(true);
                }
              : handleMint
          }
        >
          {context.t("Purchase")}
        </Button>

        <Modal
          isOpen={showBuyModal}
          toggle={closeBuyModal}
          scrollable
          className="border-0 rounded"
          centered
        >
          <ModalHeader
            toggle={closeBuyModal}
            className="text-dark bg-light fw-bold border-0 p-4"
          >
            {context.t("Purchase Legacy NFT")}
          </ModalHeader>
          <ModalBody className="text-dark bg-white border-0 p-4">
            {/* div with centered content */}
            <div className="d-flex justify-content-center">
              {showInitialLoading && <Spinner color="dark" />}
            </div>
            {showBuyModalButtons && (
              <div>
                <p className="text-dark">
                  {context.t("Select your preferred payment method.")}
                </p>
                <Button
                  className="btn mt-2"
                  block
                  disabled={!!availableAmount && disabled}
                  color="primary"
                  onClick={handleMint}
                >
                  {context.t("Pay with Crypto")}
                </Button>
                {!hasEnoughBalance && (
                  <span
                    className="form-text small text-dark"
                    style={{ fontSize: "0.7rem" }}
                  >
                    {context.t(
                      "Your ETH balance is too low. You need to have at least "
                    )}
                    {formattedMintPrice}
                    {checkStatus && checkCurrency()}
                  </span>
                )}
                {showConceriergePayment && (
                  <>
                    <p className="small pt-3">
                      Credit card payments are processed in euros.
                    </p>

                    <Button
                      className="btn mt-4"
                      outline
                      block
                      disabled={!!availableAmount && disabled}
                      color="primary"
                      onClick={handleShopfiyMint}
                    >
                      {context.t("Continue with Credit Card")}
                    </Button>
                  </>
                )}

                <small
                  className="form-text text-dark"
                  style={{ fontSize: "0.7rem" }}
                >
                  {context.t(
                    "By using this app or purchasing a token you accept the "
                  )}
                  <a
                    href="https://arcticbluebeverages.com/terms-conditions/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms and conditions of Arctic Blue Beverages
                  </a>{" "}
                  and the{" "}
                  <a
                    href="https://bowline.app/tos"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of Service of Bowline
                  </a>
                  .
                </small>
              </div>
            )}
            {showConceriegeStep && (
              <div>
                <p className="small">
                  After your payment has been processed your Legacy NFT will be
                  delivered within 24 hours. You will be notified via email once
                  the transfer is complete.
                </p>
              </div>
            )}
            {showConceriergePayment && (
              <center>
                <div
                  id="product-component-1668097358168"
                  style={{ maxWidth: "100%", width: "100%" }}
                ></div>
                {showConceriegeStep && (
                  <div className="small text-muted mt-2">
                    No Button visible? Please wait a moment...
                  </div>
                )}
              </center>
            )}
            {preventCloseModal && preventCloseAlert && (
              <Alert color="danger">
                {context.t("Please wait for the payment to be completed")}
              </Alert>
            )}
            {successAlert && (
              <Alert color="success">
                {context.t(
                  "The transaction has been sent and you will receive a notification in your bowline wallet"
                )}
              </Alert>
            )}
            <div className="d-flex justify-content-center" id="wert">
              {/* <WertModule options={wertOptions} /> */}
            </div>
          </ModalBody>
        </Modal>

        {!!availableAmount && disabled && (
          <>
            {availableAmount <= 0 ? (
              <p className="text-dark">
                {context.t("No tokens available for minting")}
              </p>
            ) : (
              <>
                {availableAmount - alreadyMintedAmount <= 0 ? (
                  <p className="text-dark">{context.t("Max tokens minted")}</p>
                ) : (
                  <p className="text-dark">
                    {context.t("Mint will start soon. Stay tuned!")}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

/**  define proptype for the 'translation' function  */
MintButtons.contextTypes = {
  t: PropTypes.func,
};

MintButtons.propTypes = {
  mintTierId: PropTypes.string,
  availableAmount: PropTypes.number,
  alreadyMintedAmount: PropTypes.number,
  mintPrice: PropTypes.string,
  disabled: PropTypes.bool,
  usdMintPrice: PropTypes.string,
  showConceriergePayment: PropTypes.bool,
};

MintButtons.defaultProps = {};

export default MintButtons;
